import axios from "axios"
import { AuthActionsTypes } from "../constants/AuthActionTypes"

const LoginAction = (userData, navigate, toast, setIsLoading) => {
    return async (dispatch) => {
        if (!userData.uid) {
            toast.error("Please enter UID!")
            setIsLoading(false)
        }
        else {
            axios.post("/login", userData)
                .then(res => {
                    console.log(res)
                    // adding token by default
                    axios.defaults.headers.common['auth-token'] = res.data.data.token;
                    localStorage.setItem("auth-student", res.data.data.token)
                    dispatch({ type: AuthActionsTypes.LOGIN_SUCCESS, payload: res.data.data })
                    toast.success("Logged in.")
                    navigate("/")
                    setIsLoading(false)
                })
                .catch(err => {
                    console.log(err)
                    console.log(err.response)
                    setIsLoading(false)
                    if (err.response) {
                        toast.error(err.response.data.msg)
                    } else {
                        toast.error("Something went wrong!")
                    }
                })
        }
    }
}


const getStudentData = () => {
    return async (dispatch) => {
        const auth = localStorage.getItem("auth-student");
        if (auth) {
            axios.get("/getStudentData", {
                headers: {
                    "auth-token": auth
                }
            })
                .then(res => {
                    console.log(res)
                    // adding token by default
                    axios.defaults.headers.common['auth-token'] = res.data.data.token;
                    localStorage.setItem("auth-student", res.data.data.token)
                    dispatch({ type: AuthActionsTypes.GET_USER_SUCCESS, payload: res.data.data })
                })
                .catch(err => {
                    console.log(err)
                    console.log(err.response)
                    dispatch({ type: AuthActionsTypes.GET_USER_FAILS, payload: {} })
                })
        }
        else {
            dispatch({ type: AuthActionsTypes.GET_USER_FAILS, payload: {} })
        }
    }
}

const logOutUser = () => {
    return (dispatch)=>{
        localStorage.removeItem("auth-student")
        dispatch({type:AuthActionsTypes.LOGOUT, payload:{}})
    }
}
export {
    LoginAction,
    getStudentData,
    logOutUser
}